interface PhoneDeviceProps {
  src: string;
  showTabBar?: boolean;
}

export default function PhoneDevice({ src, showTabBar = false }: PhoneDeviceProps) {
  return (
    <div className="phone-device">
      <div className="phone-screen">
        <iframe
          className="phone-screen-iframe"
          src={src}
          title="App demo"
          loading="lazy"
          scrolling="no"
        />
        {showTabBar && (
          <div className="absolute bottom-[20px] left-3 right-3 z-20">
            <div className="bg-[#1e293b] rounded-full py-2 px-4 flex items-center justify-between shadow-2xl" dir="ltr">
              {/* Home */}
              <div className="w-[26px] h-[26px] rounded-full flex items-center justify-center text-white">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
              </div>
              {/* QR */}
              <div className="w-[26px] h-[26px] rounded-full flex items-center justify-center text-white/40">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
              </div>
              {/* Shops */}
              <div className="w-[26px] h-[26px] rounded-full flex items-center justify-center text-white/40">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              </div>
              {/* Profile */}
              <div className="w-[26px] h-[26px] rounded-full flex items-center justify-center text-white/40">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
